import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import Pagination from "react-js-pagination";
import { itemCount } from "Constants";
import ContentIcon, { HEADING_COMMUNITY } from "ContentIcon";
import NoContent, { NO_COMMUNITY } from "NoContent";
import {
  fetchCommunity,
  searchCommunity,
  communityModal,
} from "ActionsCommunity";
import { screenHeightLeftFromTop } from "Constants";
import ItemList from "CommunityList";
import AddCommunity from "./add-community";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Community extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      search: "",
      loading: true,
      desc: LocaleStrings.preparingCommunity,
    };
  }

  componentDidMount() {
    this.props.fetchCommunity(this.props.session, 0, (callback) => {
      this.setState({ loading: false });
    });
  }

  open = () => {
    this.props.communityModal({ showModal: true });
  };

  handleSearch = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    if (search == "") {
      this.props.fetchCommunity(this.props.session, 0, (callback) => {
        this.setState({ loading: false });
      });
    } else {
      this.props.searchCommunity(
        this.props.session,
        search,
        0,
        (callback) => {}
      );
    }
    this.setState({ search, pageNumber });
  };

  additionCallback = () => {
    // after update call this method with page no. as param, it will display as your current record
    this.paginationCallback(this.state.pageNumber);
    this.callContentBoardStatus();
  };

  callContentBoardStatus = () => {
    this.props.contentBoardStatus();
  };

  paginationCallback = (pageNumber) => {
    let { search } = this.state;

    if (search == "") {
      this.props.fetchCommunity(this.props.session, pageNumber, (callback) => {
        this.setState({ loading: false });
      });
    } else {
      this.props.searchCommunity(
        this.props.session,
        search,
        pageNumber,
        (callback) => {}
      );
    }

    this.setState({ ...this.state, pageNumber });
  };

  renderList = () => {
    let { communityList } = this.props;
    let { pageNumber } = this.state;
    let pageDataLength =
      communityList && communityList.data ? communityList.data.length : 0;

    return _.map(communityList.data, (item, index) => {
      return (
        <ItemList
          key={`key_${index}`}
          listItem={item}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
          contentBoardStatus={this.callContentBoardStatus}
        />
      );
    });
  };

  render() {
    let { communityList, addCommunityModal, deviceSize } = this.props;
    let { search, pageNumber } = this.state;

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <ContentIcon heading={HEADING_COMMUNITY} />
          </div>
          <div
            className="pull-right h-100 vertical-align-center"
            style={{ marginLeft: "auto" }}
          >
            <ul className="header-buttons">
              <li>
                <input
                  className="form-control mapsearches content-table-header-searchinput"
                  placeholder="Search"
                  type="text"
                  value={search}
                  onChange={this.handleSearch}
                />
              </li>
              <li>
                <Button
                  className="btn-custom-blue schedule-add-button"
                  bsStyle=""
                  onClick={this.open}
                >
                  <img
                    style={{ paddingRight: 10, paddingBottom: 3 }}
                    src="../../style/images/header-icons/plus.png"
                  ></img>
                  {LocaleStrings.button_add_new}
                </Button>
              </li>
            </ul>
          </div>
        </div>
        <div className="clearfix"></div>
        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : communityList && communityList.count > 0 ? (
            <div className="sponsor-table">
              <table className="table">
                <thead>
                  <tr>
                    <th style={{ width: "45%" }}>
                      {LocaleStrings.content_community_table_th_tagname}
                    </th>
                    <th>{LocaleStrings.content_community_table_th_tagtype}</th>
                    <th>
                      {LocaleStrings.content_community_table_th_postcount}
                    </th>
                    <th>
                      {LocaleStrings.content_community_table_th_commentcount}
                    </th>
                    <th>{LocaleStrings.content_community_table_th_action}</th>
                  </tr>
                </thead>
                <tbody className="tbody-background">{this.renderList()}</tbody>
              </table>

              {communityList.count > itemCount ? (
                <Pagination
                  activePage={pageNumber}
                  itemsCountPerPage={itemCount}
                  totalItemsCount={communityList.count}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                  style={{ float: "right" }}
                />
              ) : (
                ""
              )}
            </div>
          ) : (
            <NoContent contentType={NO_COMMUNITY} />
          )}
        </div>

        {addCommunityModal && addCommunityModal.showModal ? (
          <AddCommunity
            history={this.props.history}
            finishOperationsCallback={this.additionCallback}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    communityList: state.communityList,
    addCommunityModal: state.addCommunityModal,
  };
}
export default connect(mapStateToProps, {
  fetchCommunity,
  searchCommunity,
  communityModal,
})(Community);
